export enum TextInputType {
  Currency = 'currency',
  Date = 'date',
  Email = 'email',
  Number = 'number',
  Password = 'password',
  Phone = 'tel',
  Signature = 'signature',
  Text = 'text',
}
